import { Component, EventEmitter, Input, Output } from '@angular/core';
import { VideoModel } from '../../models/video.model';
import { SharedModule } from '../../shared.module';

@Component({
  selector: 'app-video-modal',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './video-modal.component.html',
  styleUrl: './video-modal.component.scss',
})
export class VideoModalComponent {
  @Input() video: VideoModel | null = null;
  @Output() close: EventEmitter<any> = new EventEmitter();

  closePlayer() {
    if (document.pictureInPictureElement) {
      (document.getElementById('videoPlayer') as any).pause();
      document.exitPictureInPicture();
    }
    this.close.emit();
  }
}
